import { createApiClient } from '@avrahami/ui';
import { storeSessionHeader, tabStore } from './store-path';

/**
 * The store this tab believes is active (from its session). Every `/v1/tenant/*` call names it in
 * `x-expected-tenant`, so a call made after another tab switched stores is refused (409) instead
 * of silently acting on the other store. Kept in step with the session by `main.tsx`.
 */
let activeTenantId: string | undefined;

export function setActiveTenant(tenantId: string | undefined): void {
  activeTenantId = tenantId;
}

export function activeTenant(): string | undefined {
  return activeTenantId;
}

/** The header the tenant surface checks; none outside it, or before a store is known. */
export function tenantHeaders(
  path: string,
  tenantId: string | undefined,
): Readonly<Record<string, string>> {
  return path.startsWith('/v1/tenant/') && tenantId !== undefined
    ? { 'x-expected-tenant': tenantId }
    : {};
}

/** The server's message when the session's store is no longer the one this tab shows. */
export const STORE_CHANGED_MESSAGE = 'The active store changed in another tab';

/**
 * The app's API client (same origin, session cookie; see `@avrahami/ui`). Every call names the
 * store of this tab, so the API reads that store's session cookie (adr/0033).
 */
export const api = createApiClient({
  headers: (path) => ({
    'x-store-session': storeSessionHeader(tabStore),
    ...tenantHeaders(path, activeTenantId),
  }),
});
